export default "__VITE_ASSET__$bvV$wki__"